import React, { Component } from 'react'

export default class GroupAccessItem extends Component {

    constructor(props){
        super(props);
        this.state = {checked: props.checked};
    }

    render() {
        return (
            <div style={{display: 'flex', marginBottom: 5}}>
                    <input type="checkbox"
                           checked={this.state.checked}
                           onChange={(event) => {
                               this.setState({checked: event.target.checked});
                               event.target.checked ? this.props.onAddGroupAccess(this.props.groupName) : this.props.onRemoveGroupAccess(this.props.groupName);
                           }
                           }
                           style={{marginRight: 5, marginLeft: 5}}/>
                    <span style={{fontSize: 14, color: '#000'}}>{this.props.groupName}</span>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/GroupAccessItem.js